import { IStudent } from "../models/student";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";


const initialStudentState:any = {
    user: {},
    progress:{},
    placement:{},
    attendance:{},
    tasks:[],
    events:[],
    requests:[],
    notifications:[],
    message:""
}

const StudentSlice = createSlice({
    name:"Student",
    initialState:initialStudentState,
    reducers:{
        setStudentDetails : (state,action) => {
            state.user = {...action.payload}
        },
        setProgessDetails : (state,action) => {
            state.progress = {...action.payload}
        },
        setPlacementDetail : (state,action) => {
            state.placement = {...action.payload}
        },
        setAttendanceDetails : (state,action) => {
            state.attendance = {...action.payload}
        },
        setRequests : (state,action) => {
            state.requests = [...action.payload]
        },
        setTasks : (state,action) => {
            state.tasks = [...action.payload]
        },
        setMessage:(state,action) => {
            state.message = action.payload
        },
        setEvents:(state,action) => {
            state.events = action.payload
        },
        setNotifications:(state,action) => {
            state.notifications = action.payload
        },
        
    } 
})
export default StudentSlice;